module.exports = __webpack_public_path__ + "img/igraya-mob.15349089.png";